import { MotionPlugin } from '@vueuse/motion'
import type { App } from 'vue'

export default function (app: App) {
  app.use(MotionPlugin)
}
